import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import ReactTable from 'react-table';
import Swal from 'sweetalert2';
import moment from 'moment';
import { Link, Route, Switch } from 'react-router-dom';
import { createFetch } from '../../utils';
import UserForm from './UserForm';
import '../../styles/users.scss';
import FilterWithAuth from '../../components/FilterWithAuth';
import lang from '../../lang';
const { URL_PREFIX } = window;


class UserList extends React.Component {
    constructor() {
        super();
        this.state = {
            page: 0,
            pageSize: 10,
            userList: [],
            loading: false,
            profiles: '',
            roles: '',
        };
        this.getUser = this.getUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.getProfileName = this.getProfileName.bind(this);
    }

    componentWillMount() {
        this.getUser();
    }

    async getUser() {
        const { user } = this.props;
        const { page, pageSize } = this.state;
        try {
            const userList = await createFetch({
                path: `users/manage?pageSize=${pageSize}&page=${page}`,
                accessToken: user.accessToken,
                body: null,
                method: 'GET',
            });
            if (userList.status > 400) {
                Swal.fire('Forbidden Action', userList.message, 'warning');
                this.setState({ loading: false });
                return ;
            }
            this.setState({ userList: userList.records, loading: false });
            this.getProfileName();
        } catch (error) {
            Swal.fire(
                'An error occured',
                error.message,
                'error',
            );
        }
    }

    async getProfileName() {
        const { userList } = this.state;
        const profiles = [];
        const roles = [];

        userList.forEach((user) => {
            if (!profiles.includes(user.name)) {
                profiles.push(user.name);
            }

            if (!roles.includes(user.role)) {
                roles.push(user.role);
            }
        });

        this.setState({ profiles, roles });
    }

    async deleteUser(id) {
        const { user } = this.props;
        const { userList, loading } = this.state;

        const res = await Swal.fire({
            title: `${lang.dialogue.areYouSure}?`,
            text: lang.dialogue.willNotRecover,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: lang.common.yes,
            cancelButtonText: lang.common.no,
        });
        if (!res.value) return;
        if (loading) return;
        this.setState({ loading: true });
        try {
            const response = await createFetch({
                path: 'users/manage/delete',
                accessToken: user.accessToken,
                body: {
                    userId: id,
                },
                method: 'POST',
            });
            if (response.status === 200) {
                const profileDetail = userList.find(o => o.id === id);
                Swal.fire({
                    title: `User ${lang.common.delete}`,
                    text: `User ${profileDetail.name} ${lang.dialogue.successDeleted}`,
                    type: 'success',
                });
                this.setState({ loading: false });
                return;
            }
            let { message } = response;
            if (response.status === 400) {
                const serverValidation = response.validation.find(o => o.param === 'userId');
                message = serverValidation === null ? message : lang.serverMessage[serverValidation.msg];
            }
            throw new Error(message);
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        }
    }

    async resetPassword(id) {
        const { user } = this.props;
        const { userList, loading } = this.state;
        if (loading) return;
        this.setState({ loading: true });
        try {
            const response = await createFetch({
                path: 'users/manage/reset-password',
                accessToken: user.accessToken,
                body: {
                    userId: id,
                },
                method: 'POST',
            });
            if (response.status === 200) {
                const userDetail = userList.find(o => o.id === id);
                Swal.fire({
                    title: `User ${userDetail.name}`,
                    text: `${lang.dialogue.sendResetPwd}`,
                    type: 'success',
                });
                return;
            }
            let { message } = response;
            if (response.status === 400) {
                const serverValidation = response.validation.find(o => o.param === 'userId');
                message = serverValidation === null ? message : lang.serverMessage[serverValidation.msg];
            }
            throw new Error(message);
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                title: lang.titleError,
                text: error.message,
                type: 'error',
            });
        } finally{
            this.setState({ loading: false });
        }
    }

    defineColumn() {
        return [

        ];
    }

    render() {
        const { loading, userList, profiles, roles } = this.state;

        return (
            <div id="userPage">
                <div className="intro col-lg-4 col-sm-6">
                    <h2>Gems User</h2>
                    <p>On this page you can create, view and manage users.</p>
                </div>
                <div className="col-lg-4 col-sm-6 btn-information-section">
                    <FilterWithAuth authRequired={['menu:userManagement:users:create']}>
                        <Link to={`${URL_PREFIX}/app/users/new`} className="btn-primary btn">
                            Add New User
                        </Link>
                    </FilterWithAuth>
                </div>
                <div className="clearfix" />
                <ReactTable
                    columns={[{
                        Header: '#',
                        // accessor: 'Id',
                        width: 35,
                        filterable: false,
                        Cell: col => <p>{(col.viewIndex + 1).toString().padStart(2, '0')}</p>,
                    }, {
                        Header: 'Action',
                        accessor: 'id',
                        filterable: false,
                        width: 200,
                        Cell: col => (
                            <div className="btn-group" role="group" ariaLabel="Action">
                                <FilterWithAuth authRequired={['menu:userManagement:users:edit']}>
                                    <Link to={`${URL_PREFIX}/app/users/edit/${col.value}`} className="btn btn-info btn-sm">
                                        <i className="fa fa-edit" /> Edit
                                    </Link>
                                </FilterWithAuth>
                                <FilterWithAuth authRequired={['menu:userManagement:users:delete']}>
                                    <Link
                                        to={`${URL_PREFIX}/app/users/delete/${col.value}`}
                                        className="btn btn-danger btn-sm"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.deleteUser(col.value);
                                        }}
                                    >
                                        <i className="fa fa-trash" /> Delete
                                    </Link>
                                </FilterWithAuth>
                                <FilterWithAuth authRequired={['menu:userManagement:users:resetOtherPassword']}>
                                    <Link
                                        className="btn btn-warning btn-sm"
                                        to={`${URL_PREFIX}/app/users/reset-password/${col.value}`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.resetPassword(col.value);
                                        }}
                                    >
                                        <i className="fa fa-sync" /> Reset Pwd
                                    </Link>
                                </FilterWithAuth>
                                
                            </div>
                        ),
                    }, {
                        Header: 'Full Name',
                        accessor: 'firstName',
                        filterable: true,
                        Cell: col => (
                            <p>{col.value} {col.row._original.lastName}</p>
                        ),
                    }, {
                        Header: 'Username',
                        accessor: 'username',
                        filterable: true,
                    }, {
                        accessor: 'email',
                        Header: 'Email Address',
                        filterable: true,
                    }, {
                        accessor: 'UserProfile.name',
                        Header: 'Profile Name',
                        filterable: true,
                        Filter: cellFilter => (
                            <select className="form-control" onChange={e => cellFilter.onChange(e.target.value)}>
                                <option value={null} />
                                {profiles ? profiles.map(x => <option>{x}</option>) : null}
                            </select>
                        ),
                        Cell: col => (
                            <Link to={`${URL_PREFIX}/app/profile/${col.row._original.profileId}`}>
                                {col.row._original['UserProfile.name']}
                            </Link>
                        )
                        ,
                    }, {
                        accessor: 'role',
                        Header: 'Role',
                        filterable: true,
                        Filter: cellFilter => (
                            <select className="form-control" onChange={e => cellFilter.onChange(e.target.value)}>
                                <option value={null} />
                                {roles ? roles.map(x => <option>{x}</option>) : null}
                            </select>
                        ),
                    }, {
                        accessor: 'isActive',
                        Header: 'Active',
                        filterable: true,
                        Filter: cellFilter => (
                            <select className="form-control" onChange={e => cellFilter.onChange(e.target.value)}>
                                <option value={null} />
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        ),
                        Cell: col => (col.value ? <p className="text-center"><i className="fa fa-check" /></p> : null),
                    }, {
                        accessor: 'updatedAt',
                        Header: 'Last Modified Date',
                        Cell: col => moment(col.value).format('DD-MMM-YYYY hh:mm a'),
                    }, {
                        accessor: 'lastLogin',
                        Header: 'Last Login Date/Time',
                        Cell: col => (col.value ? moment(col.value).format('DD-MMM-YYYY hh:mm a') : ''),
                    }]}
                    loading={loading}
                    data={userList}
                    onPageChange={page => this.setState({ page }, this.getUser)}
                />
                <Switch location={this.props.location}>
                    <Route path={`${URL_PREFIX}/app/users/edit/:id`} component={UserForm} exact />
                    <Route path={`${URL_PREFIX}/app/users/new`} component={UserForm} exact />
                </Switch>
            </div>
        );
    }
}

UserList.propTypes = {
    user: propTypes.object.isRequired,
    location: propTypes.object.isRequired,
};

UserList.defaultProps = {
    // selectedYear: moment().year(),
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});


export default connect(mapStateToProps, mapDispatchToProps)(UserList);
